<template>
  <router-view :key="$route.fullPath" />
</template>

<style lang="scss">
// Import Main styles for this application
@import 'styles/style';
@import 'sweetalert2/src/sweetalert2.scss';
</style>


<style src="@vueform/multiselect/themes/default.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>